<template>
  <div class="premium-background" :class="{ 'is-dark': themeStore.isDark }">
    <!-- Partículas (Perlage) -->
    <div class="particles-layer">
      <div 
        v-for="i in 75" 
        :key="i" 
        class="bubble" 
        :style="getBubbleStyle(i)"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { useThemeStore } from '../stores/theme'

const themeStore = useThemeStore()

// Gera estilos aleatórios para cada bolha para criar um fluxo orgânico
const getBubbleStyle = (index) => {
  // Tamanhos diversos: 3px a 14px (estilo perlage de champagne refinado)
  const size = Math.random() < 0.6 ? (Math.random() * 4 + 3) : (Math.random() * 6 + 7); 
  const left = Math.random() * 100; // 0% a 100% horizontal
  const duration = Math.random() * 14 + 9; // 9s a 23s subindo
  const delay = Math.random() * -35; // Começam em pontos aleatórios
  const opacity = Math.random() * 0.30 + 0.25; // Opacidade entre 0.25 e 0.55
  
  // Wobble aleatório dinâmico para os lados
  const wobbleTranslateX = (Math.random() * 60 - 30) + 'px'; 
  
  return {
    width: `${size}px`,
    height: `${size}px`,
    left: `${left}%`,
    animationDuration: `${duration}s`,
    animationDelay: `${delay}s`,
    opacity: opacity,
    '--wobble-x': wobbleTranslateX
  }
}
</script>

<style scoped>
.premium-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: -1;
  overflow: hidden;
  /* Fundo claro sofisticado e quente (champagne/creme) */
  background: radial-gradient(circle at 50% 30%, #ffffff 0%, #f4eee6 80%);
  pointer-events: none;
}

.premium-background.is-dark {
  /* Fundo grafite profundo sofisticado, elegante e com relevo (nunca preto absoluto gótico) */
  background: radial-gradient(circle at 50% 30%, #171822 0%, #101116 80%);
}

/* PARTICULAS (BOLHAS DE GÁS OCAS) */
.particles-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.premium-background.is-dark .particles-layer {
  opacity: 0.95; /* Partículas bem nítidas e elegantes no modo escuro */
}

.bubble {
  position: absolute;
  bottom: -30px;
  background-color: transparent; /* Oca por dentro */
  border: 1px solid rgba(255, 255, 255, 0.65); /* A base da borda, ajustada pela opacidade inline */
  border-radius: 50%;
  
  /* Linear é fundamental para não ter pausa/lentidão no início e fim do loop */
  animation-name: riseWobble;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  box-shadow: 0 0 3px rgba(255, 255, 255, 0.15);
}

.premium-background:not(.is-dark) .bubble {
  border-color: rgba(0, 0, 0, 0.45);
  box-shadow: none;
}

/* Simula o gás subindo:
   - A velocidade vertical é constante (linear)
   - O balanço lateral faz um formato de onda ('S')
   - O tamanho aumenta levemente ao subir (como gases expandindo) */
@keyframes riseWobble {
  0% {
    transform: translateY(0) translateX(0) scale(1);
  }
  25% {
    transform: translateY(-30vh) translateX(var(--wobble-x)) scale(1.1);
  }
  50% {
    transform: translateY(-60vh) translateX(0) scale(1.2);
  }
  75% {
    transform: translateY(-90vh) translateX(calc(var(--wobble-x) * -1)) scale(1.35);
  }
  100% {
    transform: translateY(-120vh) translateX(0) scale(1.5);
  }
}
</style>
